import { render } from "./AddNewBook.vue?vue&type=template&id=5a830eb8"
import script from "./AddNewBook.vue?vue&type=script&lang=js"
export * from "./AddNewBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__